import { dashboardApiURL } from "API/urls/dashboard.api";
import { axiosInstance } from "configs/axios";

export const taskCompletionStatusOldApi = async () => {
  try {
    const response = await axiosInstance.get(
      dashboardApiURL.taskCompletionStatusOld
    );
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
